import { Component, OnDestroy } from "@angular/core";
import {
  AlertController,
  NavController,
  NavParams,
  ViewController,
} from "ionic-angular";
import { AmendedAction } from "models/order-management/amendedAction";
import { OrderResponse } from "models/order-management/orderResponse";

@Component({
  selector: "read-back-and-verified",
  templateUrl: "read-back-and-verified.html",
})
export default class ReadBackAndVerified implements OnDestroy {
  order: OrderResponse;

  public constructor(
    private alertCtrl: AlertController,
    private navCtrl: NavController,
    private viewCtrl: ViewController,
    private navParams: NavParams
  ) {
    this.order = this.navParams.data.order;
  }

  ngOnDestroy(): void {}

  cancel(): void {
    let alert = this.alertCtrl.create({
      title: "Cancel Confirmation",
      message: "Are you sure you wish to cancel",
      buttons: [
        {
          text: "No",
          handler: () => {},
        },
        {
          text: "Yes",
          handler: () => {
            this.navCtrl.pop();
          },
        },
      ],
    });
    alert.present();
  }

  modifyReadBackAndVerified() {
    let amendedAction: AmendedAction = {
      reason: "Verbal Acknowledgement of Order updated",
      properties: [
        {
          previousValue: this.order.readBackAndVerified,
          newValue: true,
          propertyName: "readBackAndVerified",
        },
      ],
    };
    this.viewCtrl.dismiss(amendedAction);
  }
}



// WEBPACK FOOTER //
// ./src/pages/orders-entry-om/read-back-and-verified/read-back-and-verified.ts